import React from 'react';
import { useTranslation } from 'react-i18next';
import './ConfirmModal.css';

interface ConfirmModalProps {
  title?: string;
  message?: string;
  description?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ title, message, description, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div className="confirm-modal-content" onClick={(e) => e.stopPropagation()}>
        {title && <div className="confirm-modal-title">{title}</div>}
        {message && <div className="confirm-modal-message">{message}</div>}
        {description && <div className="confirm-modal-description">{description}</div>}
        <div className="confirm-modal-actions">
          <button onClick={onCancel} className="btn-cancel">
            {t('common.cancel')}
          </button>
          <button onClick={onConfirm} className="btn-primary">
            {t('common.ok')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
